/*
Defines the custom element <ravel-slider>
*/

import { RavelSlider } from './src/RavelSlider.js';

customElements.define('ravel-slider', RavelSlider);
